/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-curly-newline */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import styles from './styles'
import { clearQaCookies, setQaCookies } from '../../utils/qaCookies'

const QaInfo = ({ qaInfo }) => {
  const [qaInfoState, setQaInfoState] = useState(() => qaInfo)
  const [isHidden, setIsHidden] = useState(true)
  const [inSync, setInSync] = useState(() => Object.is(qaInfoState, qaInfo))

  useEffect(() => {
    setQaCookies(null, qaInfoState)
    const relevantQaInfo = {
      tpPrefix: qaInfo.tpPrefix,
      clearCache: qaInfo.clearCache,
    }
    const relevantQaInfoState = {
      tpPrefix: qaInfoState.tpPrefix,
      clearCache: qaInfoState.clearCache,
    }
    setInSync(isEqual(relevantQaInfoState, relevantQaInfo))
  }, [qaInfoState])

  const handleReset = () => {
    clearQaCookies(['tpPrefix', 'clearCache'])
    setQaInfoState({})
  }

  return (
    <div className={`qa-info ${isHidden ? 'hidden' : ''}`}>
      <span className="message">
        {' '}
        {inSync ? '' : 'Refresh to see changes'}{' '}
      </span>
      <div className="form-wrap">
        <strong>API</strong>:
        <br />
        <label htmlFor="qaApi">
          QA
          <input
            type="radio"
            name="qaApi"
            id="qaApi"
            value="qa"
            onChange={(e) => setQaInfoState({ ...qaInfoState, tpPrefix: '' })}
            checked={qaInfoState.tpPrefix !== 'prod'}
          />
        </label>
        <label htmlFor="tpPrefix" hidden={qaInfoState.tpPrefix === 'prod'}>
          TP:
          <input
            placeholder="12345"
            name="tpPrefix"
            id="tpPrefix"
            size={6}
            value={qaInfoState.tpPrefix || ''}
            onChange={(e) =>
              setQaInfoState({ ...qaInfoState, tpPrefix: e.target.value })
            }
          />
        </label>
        <br />
        <label htmlFor="prodApi">
          Prod
          <input
            type="radio"
            name="prodApi"
            id="prodApi"
            value="prod"
            onChange={(e) =>
              setQaInfoState({ ...qaInfoState, tpPrefix: 'prod' })
            }
            checked={qaInfoState.tpPrefix === 'prod'}
          />
        </label>
      </div>
      <div className="form-wrap">
        <strong>Caching</strong>:{' '}
        <input
          id="caching"
          type="checkbox"
          value={qaInfoState.clearCache || false}
          checked={!qaInfoState.clearCache}
          onChange={(e) =>
            setQaInfoState({ ...qaInfoState, clearCache: !e.target.checked })
          }
        />
      </div>
      <button className="reset" type="button" onClick={handleReset}>
        Restore Defaults
      </button>
      <button
        className="toggle"
        type="button"
        onClick={() => setIsHidden(!isHidden)}
      >
        {isHidden ? 'QA' : 'Hide'}
      </button>
      <style jsx>{styles}</style>
    </div>
  )
}

QaInfo.propTypes = {
  qaInfo: PropTypes.shape({
    tpPrefix: PropTypes.string,
    clearCache: PropTypes.bool,
  }),
}

QaInfo.defaultProps = {
  qaInfo: {},
}

export default QaInfo
